import type { EntityRegistry } from '@sites/entity-migrator';

import { LegacyFormWidgetEntitySchema, type FormWidgetEntity } from './schemas';

export const formRegistry: EntityRegistry<FormWidgetEntity> = {
    name: 'form',
    getEntitySchema: (entity: unknown) => {
        if (typeof entity !== 'object' || entity === null) return null;
        // Dispatch on `name` — the existing widget discriminator. The legacy
        // shape has no entitySubType field; a future `default` subtype will add
        // one and branch here before falling back to the legacy variants.
        // The schema normalises old data on load (`createContactAndDeal`,
        // `formView`) — see `legacyWidgetRegistries` and `normalizeLegacyEntity`.
        const name = (entity as { name?: unknown }).name;
        if (name === 'form') return LegacyFormWidgetEntitySchema;
        return null;
    },
};
